import CapacitacionesContent from "../components/FormacionDesarrollo/Capacitaciones/CapacitacionesContent";
import ModalConfirmFinishCourse from "../components/FormacionDesarrollo/Capacitaciones/modals/ModalConfirmFinishCourse";
import TrainingState from "../context/FormacionDesarollo/TrainingState";

const CapacitacionesScreen = () => {
  return (
    <TrainingState>
      <CapacitacionesContent></CapacitacionesContent>
    </TrainingState>
  );
};
export default CapacitacionesScreen;
